<template>
  <div class="system-set table-first-style">
    <el-row class="search-title common-table-top" style="margin-top: 20px;padding-right:0">
      <el-col :span="4" class="table-title" style="text-align: left">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span>角色管理</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" v-show="btnType.add" class="btn-link-large add-btn btn-right" style="margin-top: 10px" @click="openAddDialog">
          添加角色
        </el-button>
      </el-col>
    </el-row>
    <el-table
            :data="tableData"
            v-loading="loading">
      <template slot="empty">
        <div class="newTableEmpty">暂无数据，去<span @click="openAddDialog">新建</span></div>
      </template>
      <el-table-column
              label="角色名称"
              prop="title">
      </el-table-column>
      <el-table-column
              label="角色描述"
              prop="remark">
        <template slot-scope="scope">
          {{scope.row.remark === null ? '' : scope.row.remark.length > 8 ? scope.row.remark.substring(0,8) + '...': scope.row.remark}}
        </template>
      </el-table-column>
      <el-table-column
              label="添加时间">
        <template slot-scope="scope">
          {{ scope.row.createTimeStr }}
        </template>
      </el-table-column>
      <el-table-column
              label="是否启用"
              prop="status">
        <template slot-scope="scope">
          <!-- 1正常0 禁用 -->
          <div class="op-link">
            <!-- {{ scope.row.status === 1 ? '禁用':'启用' }} -->
            <el-switch
                    :value="scope.row['status'] == 1 ? true : false"
                    @change="switchChange(scope.row)">
            </el-switch>
          </div>
        </template>
      </el-table-column>
      <el-table-column
              width="180"
              label="操作">
        <template slot-scope="scope">
          <div>
            <!-- <span>
              <el-button type="primary" size="small" @click="toSet(scope.row.id)" class="editBtn">
              权限设置
              </el-button>
            </span> -->
            <div class="op-link" v-show="btnType.permission_setting"
                 @click="toSet(scope.row.id)">
              权限设置
            </div>
            <!-- <span>
            <el-button type="primary" size="small" @click="openEditDialog(scope.row)" class="editBtn" style="font-style: normal">
            编辑
            </el-button>
          </span>
          <span>
            <el-button
            size="small"
            type="danger"
            class="removeBtn"
            @click="confirmDelete(scope.row)">
            删除
            </el-button>
          </span> -->
            <div class="op-link editColor" v-show="btnType.edit"
                 @click="openEditDialog(scope.row)">
              编辑
            </div>
            <div class="op-link deleteColor" v-show="btnType.del"
                 @click="confirmDelete(scope.row)">
              删除
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <div class="table-foot">
        <el-pagination class="table-foot-pagination totalPage"
                       background
                       @size-change="handleSizeChangeTotal"
                       @current-change="handleCurrentChangeTotal"
                       :page-size="limit"
                       :current-page="page"
                       layout="total, prev, pager, next, jumper"
                       :total="totalCountTotal">
        </el-pagination>
      </div>
    </div>
    <!--添加角色弹窗-->
    <el-dialog class="cellDialog base-dialog"
               title="添加角色"
               :visible.sync="adddialog"
               width="520px">
      <el-form ref="addForm"
               :model="addForm"
               :rules="rules">
        <el-form-item label="角色名称:"
                      :label-width="addLabelWidth"
                      prop="name">
          <el-input class="stockInput"
                    type="text"
                    v-model="addForm.name"
                    auto-complete="off"
                    placeholder="输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色描述:"
                      :label-width="addLabelWidth">
          <el-input v-model="addForm.remark"
                    class="add-groups-input"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 4}"
                    maxlength="100"
                    placeholder="请输入描述内容">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="margin-top: 10px">
        <el-button class="dialog-cancel-btn"
                   @click="adddialog = false"
                   style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn"
                   style="margin-right: 32px"
                   type="primary"
                   @click="submitForm('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑角色弹窗-->
    <el-dialog class="cellDialog base-dialog"
               title="编辑角色"
               :visible.sync="editdialog"
               width="520px">
      <el-form ref="addForm"
               :model="editForm">
        <el-form-item label="角色名称:"
                      :label-width="addLabelWidth">
          <el-input class="stockInput"
                    type="text"
                    v-model="editForm.name"
                    auto-complete="off"
                    placeholder="输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色描述:"
                      :label-width="addLabelWidth">
          <el-input v-model="editForm.remark"
                    class="add-groups-input"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 4}"
                    maxlength="100"
                    placeholder="请输入描述内容">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="margin-top: 10px">
        <el-button class="dialog-cancel-btn"
                   @click="editdialog = false"
                   style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn"
                   style="margin-right: 32px"
                   type="primary"
                   @click="confirmEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addRole, getRoleList, editRole, deleteRole, useOrBanRole } from '@/api/customer.js'
import { butonsList,getMenId } from '@/api/analyse.js'
export default {
  data () {
    return {
      loading: true,
      adddialog: false,
      editdialog: false,
      tableData: [],
      editId: '',
      click: 1,
      addLabelWidth: '80px',
      addForm: {
        name: '',
        remark: ''
      },
      limit: 10,
      page: 1,
      totalCountTotal: 0,
      editForm: {
        name: '',
        remark: ''
      },
      multipleSelection: [],
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      },
      btnType:{
        'edit':false,
        'add':false,
        'permission_setting':false,
        'edit':false,
        'del':false,
        'status_change':false
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAdd()
        } else {
          return false
        }
      })
    },
    queryBtnList(){
      var itemId = getMenId(this.$route.path)
      butonsList({systemCode: 'ZY_INTELLIQUOR',menuId:itemId}).then((res)=>{
        if(res.data.code == '200'){
          var btnList = this.btnType
          for(let i = 0, k = res.data.result.length; i < k; i ++){
            for(let m in btnList){
              if(res.data.result[i].perms.indexOf(m) != -1){
                this.btnType[m] = true
              }
            }
          }
        }
      })
    },
    // 跳转
    toSet (id) {
      router.push({ name: 'positionRuleSetNew', query: { id: id } })
    },
    // 分页
    handleSizeChangeTotal (val) {
      this.limit = val
      this.load()
    },
    handleCurrentChangeTotal (page) {
      this.page = page
      this.load()
    },
    // 打开角色编辑弹窗
    openEditDialog (item) {
      this.editdialog = true
      this.editForm.name = item.title
      this.editForm.remark = item.remark
      this.editId = item.id
    },
    // 打开添加角色弹窗
    openAddDialog () {
      this.adddialog = true
      this.addForm.name = ''
      this.addForm.remark = ''
    },
    // 确认编辑角色
    confirmEdit () {
      editRole(this.editForm.name, this.editForm.remark, [], this.editId).then((res) => {
        if (res.data.code === '200') {
          _g.toastMsg('success', '编辑成功')
          this.editdialog = false
          this.load()
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 确认添加角色
    confirmAdd () {
      addRole(this.addForm.name, this.addForm.remark).then((res) => {
        if (res.data.code === '200') {
          _g.toastMsg('success', '添加成功')
          this.adddialog = false
          this.load()
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 加载角色列表
    load () {
      this.loading = true
      getRoleList(this.page, this.limit).then((res) => {
        if (res.data.code === '200') {
          this.tableData = res.data.result.list
          this.totalCountTotal = res.data.result.total
        }else{
          this.tableData = []
          this.totalCountTotal = 0
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    switchChange (item) {
      // item.status = item.status === 0 ? 1 : 0
      let ids = []
      ids.push(item.id)
      if (this.click === 1) {
        this.click = 0
        var status = item.status === 0 ? 1 : 0
        this.$nextTick(() => {
          useOrBanRole(ids, status).then((res) => {
            if (res.data.code === '200') {
              _g.toastMsg('success', res.data.message)
              this.load()
              this.click = 1
            }else{
              _g.toastMsg('error', res.data.message)
              this.click = 1
            }
            // if (res.data.code === 10230702) {
            //   _g.toastMsg('error', res.data.message)
            //   this.load()
            //   this.click = 1
            // }
          })
        })
      }
    },
    selectItem (val) {
      this.multipleSelection = val
    },
    confirmDelete (item) {
      this.$confirm('确认删除该角色?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRole(item.id).then((res) => {
          if (res.data.code === '200') {
            _g.toastMsg('success', '删除成功')
            this.load()
          } else {
            _g.toastMsg('error', res.data.message)
          }
        })
      }).catch((error) => {
      })
    },
    getPositions () {
    }
  },
  created () {
    this.load()
    this.getPositions()
    this.queryBtnList()
  },
  computed: {
    addShow () {
      return _g.getHasRule('posts-save')
    },
    editShow () {
      return _g.getHasRule('posts-update')
    },
    deleteShow () {
      return _g.getHasRule('posts-delete')
    }
  },
  components: {
  }
}
</script>
